function customVideoDivMouseDownLaptop(event,url){
        var videoHtml = '<iframe width="100%" height="100%" src="' + url + '" class="youtube-player youtubeVideo  customVideoListYoutubeVideoLaptop" frameborder="0"></iframe>';

        $(".youtubeVideoLaptopDiv").prepend(videoHtml);
        $(".videoPopupShowLaptopDiv").show();
    }

    $(".video-close-laptop").click(function() {
        $(".videoPopupShowLaptopDiv").hide();
        $(".customVideoListYoutubeVideoLaptop").remove();
    })

    var swiper = new Swiper("#customVideoListLaptopSwiper", {
        slidesPerView: 'auto',
        preventClicks:'false',
        spaceBetween: 16,
        // freeMode: {
        //     enabled: true,
        //     sticky: true,
        // },
    });